const initialState = {
  isAddingConstructionOrderPayment: false,
  isFetchingConstructionOrderPayment: false,
  constructionOrderPaymentList: [],
  orderTotalReceived: 0,
};

const ConstructionOrderPaymentReducer = (state = initialState, action) => {
  switch (action.type) {

    case "REQUEST_ADD_CONSTRUCTION_ORDER_PAYMENT":
      return { ...state, isAddingConstructionOrderPayment: true };
    case "SUCCESS_ADD_CONSTRUCTION_ORDER_PAYMENT":
      return { ...state, isAddingConstructionOrderPayment: false };
    case "ERROR_ADD_CONSTRUCTION_ORDER_PAYMENT":
      return { ...state, isAddingConstructionOrderPayment: false };


    case "REQUEST_GET_CONSTRUCTION_ORDER_PAYMENT":
      return { ...state, isFetchingConstructionOrderPayment: true };
    case "SUCCESS_GET_CONSTRUCTION_ORDER_PAYMENT":
      return { ...state, constructionOrderPaymentList: action.payload.data, orderTotalReceived: action.payload.totalReceived || 0, isFetchingConstructionOrderPayment: false };
    case "ERROR_GET_CONSTRUCTION_ORDER_PAYMENT":
      return { ...state, isFetchingConstructionOrderPayment: false };


    case "DELETE_SUCCESS_CONSTRUCTION_ORDER_PAYMENT":
      return { ...state, constructionOrderPaymentList: state.constructionOrderPaymentList.filter((item) => item._id !== action.paymentId) };


    case "RESET_CONSTRUCTION_ORDER_PAYMENT_DATA":
      return { ...state, constructionOrderPaymentList: [], orderTotalReceived: 0 };


    default:
      return state;
  }
};
export default ConstructionOrderPaymentReducer;
